import React, { useEffect } from "react";
import { observer } from "mobx-react";
import ConnectLinkedInButton from "./ConnectLinkedInButton";
import { linkedInReplyState } from "./state";
import ConnectedLinkedInList from "./ConnectedLinkedInList";
import ConnectedLinkedInConfigure from "./ConnectedLinkedInConfigure";
import { notifyOpener } from "Pages/Dashboard/connectApps/oauthPopupBridge";
import linkedInUtils from "./common/linkedInUtils";

// The OAuth popup is opened via window.open(authUrl, "linkedInOAuthConnect", ...)
// in linkedInUtils.js. window.name survives the cross-origin round-trip through
// Unipile/LinkedIn even after Chrome's COOP severs window.opener, so it's the
// only reliable way left to tell "I'm the OAuth popup" from "a normal tab on
// this settings route" once we land back here.
const isOAuthPopup = () => window.name === "linkedInOAuthConnect";

const LinkedInAccounts = observer((props = {}) => {
  useEffect(() => {
    if (isOAuthPopup()) {
      (async () => {
        // Unipile appends account_id to the redirect URL only on an actual
        // successful login - its presence is what tells the backend this
        // was a real attempt, not just a closed popup, so it's worth
        // awaiting before we close (a fire-and-forget call risks getting
        // cancelled by the browser when the window closes underneath it).
        const accountId = new URLSearchParams(window.location.search).get(
          "account_id"
        );
        if (accountId) {
          await linkedInUtils.markOAuthConnectionStarted(accountId);
        }
        // window.opener may already be null (COOP), so fan the result out
        // over postMessage + BroadcastChannel + localStorage and let the
        // opener close this popup with the handle it still owns from
        // window.open(...).
        notifyOpener({ type: "LINKEDIN_OAUTH_POPUP_DONE" });
        try {
          window.close();
        } catch (e) {
          // opener-side listener (linkedInUtils.js) closes us instead
        }
      })();
      return;
    }
    linkedInReplyState.setLinkedInDataLoading(true);
    linkedInReplyState.getLinkedInAccounts();
  }, []);

  if (isOAuthPopup()) {
    return <div className="connectLinkedInBody">Connecting your LinkedIn account…</div>;
  }

  return (
    <div
      className={`connectLinkedInBody ${
        linkedInReplyState?.linkedInConnected ? "linkedInAccountConnected" : ""
      }`}
    >
      {linkedInReplyState?.linkedInConnected ? (
        linkedInReplyState?.showConfigure ? (
          <ConnectedLinkedInConfigure />
        ) : (
          <div className="connectedLinkedInAccountsBody">
            {/* <ConnectedLinkedInHeader /> */}
            <ConnectedLinkedInList />
          </div>
        )
      ) : (
        <ConnectLinkedInButton />
      )}
    </div>
  );
});

export { LinkedInAccounts };
export default LinkedInAccounts;
